import React, { useState, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import i18n from 'translations/i18n';
import { calculateNodeOffset } from 'clean/utils/functions';
import Paper from 'clean/components/common/Paper/Paper';
import EntryTitle from 'clean/components/common/EntryTitle/EntryTitle';
import TextField from 'clean/components/common/TextField/TextField';

import './DetailsPopup.scoped.scss';
import getGradeName from '../helper';

interface Props {
  gradeItem: any;
  gradeName: string;

  rootNode: React.RefObject<HTMLElement>;
  onClose: () => void;
}

const DetailsPopup: React.FC<Props> = ({ rootNode, gradeName, gradeItem, onClose }) => {
  const topOffset = 90;
  const detailsNode = useRef(null);
  const { t } = useTranslation();

  const [offset, setOffset] = useState({ x: null, y: null });

  const updateOffset = () => {
    if (detailsNode.current) {
      const nodeOffsets = calculateNodeOffset(rootNode.current);
      let top = nodeOffsets.y - topOffset;
      let left = nodeOffsets.x + rootNode.current.offsetWidth - 1; // -1 is so the border doesn't glitch out when running non-native resolution

      // Means that there is a collision on right side, and we should move it back to the left side
      if (window.innerWidth - left < detailsNode.current.offsetWidth) {
        left -= detailsNode.current.offsetWidth + rootNode.current.offsetWidth - 1; // The same reason
      }

      if (window.innerHeight - top < detailsNode.current.offsetHeight) {
        top -= detailsNode.current.offsetHeight - (window.innerHeight - top) + 10;
      }

      setOffset({ x: left, y: top });
    }
  };

  useEffect(updateOffset, [detailsNode.current]);

  return (
    <div
      ref={detailsNode}
      style={{ '--offset-x': offset.x, '--offset-y': offset.y } as React.CSSProperties}
      className="grade-details-wrapper"
    >
      <div
        onClick={e => {
          e.stopPropagation();
          onClose();
        }}
        className="backdrop-overlay"
      ></div>
      <div className="wrapper">
        <Paper>
          <div className="content">
            <div className="title">{gradeItem?.assignment?.title}</div>

            <div
              className="close"
              onClick={e => {
                e.stopPropagation();
                onClose();
              }}
            />

            <div className="entry">
              <EntryTitle title={t('common:Date')}>
                {
                  <TextField
                    disabled
                    value={DateTime.fromISO(gradeItem?.assignment?.due_at)
                      .setLocale(i18n.language)
                      .toFormat('MM.dd.y')}
                    onChange={() => null}
                  />
                }
              </EntryTitle>
            </div>

            <div className="entry">
              <EntryTitle title={t('common:Type')}>
                <TextField disabled value={gradeItem.assignment.type} onChange={() => null} />
              </EntryTitle>
            </div>

            <div className="entry">
              <EntryTitle title={t('common:Teacher')}>
                <TextField
                  disabled
                  value={gradeItem.subject.teacher_subjects[0]?.teacher?.user?.full_name}
                  onChange={() => null}
                />
              </EntryTitle>

              {/* <div className="grade">
                <EntryTitle title={t('common:Mark')}>
                  <TextField disabled value={gradeName} onChange={() => null} />
                </EntryTitle>
              </div> */}
            </div>

            <div className="entry">
              <EntryTitle title={t('common:Mark')}>
                <TextField disabled value={getGradeName(gradeName)} onChange={() => null} />
              </EntryTitle>
            </div>

            <div className="entry">
              <EntryTitle title={t('common:Comment')}>
                <TextField disabled value={gradeItem?.comment} onChange={() => null} />
              </EntryTitle>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default DetailsPopup;
